import parse from "html-react-parser";

export default function HomeRemarks({ venue }: any) {
  return (
    <div className="listingSection__wrap">
      <div className="text-neutral-6000 dark:text-neutral-300">{parse(venue!["venue_remarks"] ?? "")}</div>
    </div>
  );
}
